module.exports = __webpack_public_path__ + "static/favicon-192-b811905416575a9c89a0e19fabf6ec51.png";